import { createReducer } from '@reduxjs/toolkit';
import { SET_DATA_ALBUMS_SLIDER } from '../actions/AlbumsSliderActions';


/*
*IMPORTANT: this is the albums of the moment component, nothing specific to any artist!
*It might make sense to make this a standalone component, to logically seperate it better...
*/


const initialState = {
    albumSlides: [],
};

const AlbumSlider = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_DATA_ALBUMS_SLIDER, (state, action) => {
            state.albumSlides = action.albumSlides;
        });
});

export default AlbumSlider;
